import { cn } from "@/utils/cn";
import { Button } from "../button";

export default function BtnSuccess({
  children,
  className,
  ...props
}: {
  children: React.ReactNode;
  className?: string;
} & React.ComponentProps<typeof Button>) {
  return (
    <Button
      variant={"default"}
      className={cn(
        " rounded-full px-7 py-5 text-[15px]  border-2 border-transparent bg-sig hover:bg-sig/90",
        className
      )}
      {...props}
    >
      {children}
    </Button>
  );
}
